import { Post } from "../utils/http.js"

export function getValidCouponList(params) {
  return Post("/api/coupon/list/valid", params)
}

export function getInvalidCouponList(params) {
  return Post("/api/coupon/list/invalid", params)
}

export function exchangeCoupon(params) {
  return Post("/api/coupon/exchange", params)
}

export function checkCoupon(params) {
  return Post("/api/order/couponCheck", params)
}
// 选中券后计算优惠
export function calcCoupon(params) {
  return Post("/api/order/couponCalc", params)
}
